<template>
    <v-dialog v-model="dialog" persistent width="400" @keydown.esc="close()">

        <v-system-bar dark dense color="primary">
            <span class="white--text">Duplica</span>
        </v-system-bar>



        <v-card>
            <v-card-text style="font-size:15px;" class="pa-3">Vuoi duplicare il documento ?</v-card-text>

            <v-alert :value="true" type="warning" v-if="visAvvisoListinoObsoleto" class="title pa-0 mx-2" dense
                style="margin-bottom: 20px;  margin-top: 20px;">
                {{ visAvvisoListinoObsoleto }}
            </v-alert>

            <v-checkbox v-if="visAvvisoListinoObsoletoTest" v-model="checkCambio" label="Cambia listino"></v-checkbox>


            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="conferma()" :loading="attesa" outlined>Si</v-btn>
                <v-btn color="primary" @click.native="close()" :disabled="attesa" outlined>No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>


<script>

import { get_testataOrdine, duplica_ordine, get_listini, set_listino, duplica_aggiornaRighe } from "@/api/api.ordini.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        idPrev: { type: Number, default: 0 },
    },


    data: () => ({
        datiTestata: {},
        attesa: false,
        idPrevNew: 0,
        checkCambio: false
    }),

    methods: {

        async caricaDati() {
            this.idPrevNew = 0
            this.checkCambio = false

            if (this.dialog == false)
                return

            let res = await get_testataOrdine(this.idPrev)
            this.datiTestata = res.data

        },

        async conferma() {

            this.attesa = true

            try {
                let res = await duplica_ordine(this.idPrev);

                this.idPrevNew = parseInt(res.data)

                // Agggiorno il listino
                await this.aggiornaListino()


            } catch (error) {
                console.log(this.$i2kFunctions.getErrorMsg(error));
                this.$toast.alert(this.$i2kFunctions.getErrorMsg(error));
            }

            this.attesa = false

            this.close()
        },

        async aggiornaListino() {

            // Controllo listino 
            if (this.datiTestata.ListinoInVigore)
                return

            // su esterno temporanemente disattivo
            if (this.utenteInterno == false)
                return

            // Su utente interno non aggiorno il listino 
            if (this.utenteInterno && this.checkCambio == false)
                return

            let res = await get_listini(this.idPrev)
            let listini = res.data

            // Ricavo il listino in vigore
            let listinoInVigore = listini.find(f => f.InVigore == true).CodListino

            // Imposto il listono nuovo
            await set_listino(this.idPrevNew + "/" + listinoInVigore)

            // Aggiorno le righe
            await duplica_aggiornaRighe(this.idPrevNew)
        },


        close() {
            this.$emit("chiudiDialog", this.idPrevNew);
        },

    },

    watch: {
        dialog(val) {
            return !val || this.caricaDati();
        },
    },

    computed: {

        visAvvisoListinoObsoleto() {
            let res = ""
            if (this.datiTestata.ListinoInVigore === false) {
                res = "IL LISTINO NON È AGGIORNATO"
                /*    if (this.utenteInterno == false)
                       res += "Il preventivo verrà aggiornato con il nuovo listino" */
            }


            return res
        },

        visAvvisoListinoObsoletoTest() {
            return this.visAvvisoListinoObsoleto && (this.nomeUtente == "NOVARO" || this.nomeUtente == "MARIO1" || this.nomeUtente == "paolo")
        },


        getRole() {
            return this.$store.getters["user/getRole"];
        },

        utenteInterno() {
            return (
                this.getRole.toLowerCase() === "Interno".toLowerCase() ||
                this.getRole.toLowerCase() === "AgenteInterno".toLowerCase()
            );
        },

        nomeUtente() {
            return this.$store.getters["user/getUser"];
        },

    }

}

</script>